import React from 'react';
import Container from '@/container';
import {Grid, Row, Col} from '@/grid';
import {H1, P} from '@/typography';
import Link from '@/links';
import {SectionPaddingHeroToZero} from '@/section';
import PictureWrapper from '@/ui/images-wrapper';
import {withMarginTopZeroToXxl} from '@/hocs/withSpacing';
import {withGreen800, withNeutral800} from '@/hocs/withColors';
import {withHomeSubP} from '@/hocs/withFontType';

const imgPath = '/static/images/security/hero/';

const H1Green800 = withGreen800(H1);
const SubPNeutral800 = withNeutral800(withHomeSubP(P));
const SectionHero = withMarginTopZeroToXxl(SectionPaddingHeroToZero);
const ContainerHero = withMarginTopZeroToXxl(Container);

const SecurityHero = () => (
  <SectionHero>
    <ContainerHero>
      <Grid fluid>
        <Row center="xs" start="lg" middle="lg">
          <Col xs={12} lg={6}>
            <H1Green800>Enterprise-level data protection</H1Green800>
            <SubPNeutral800>
              Workable ensures your data stays secure and compliant with stringent controls, so you
              can focus on HR without worry.
            </SubPNeutral800>
            <Link
              href="/static/downloads/security-white-paper.pdf?1.3"
              variant="primary"
              target="_blank"
              linkTitle="Read our security white paper">
              Read our security white paper
            </Link>
          </Col>
          <Col xs={12} lg={6}>
            <PictureWrapper
              imgPath={imgPath}
              imageUrl="security-hero"
              imageTypeFallback="jpg"
              alt="Workable security"
              fetchpriority="high"
              loading="eager"
              width={584}
              height={624}
            />
          </Col>
        </Row>
      </Grid>
    </ContainerHero>
  </SectionHero>
);

export default SecurityHero;
